'use client';

import logTrailDetailsActionTapped from '@alltrails/amplitude/events/logTrailDetailsActionTapped';
import Link from '@alltrails/denali/components/Link';
import type { TrailId } from '@alltrails/types/TrailId';

type TrailLocationLinkProps = {
  className?: string;
  trailId: TrailId;
  trailLocationName: string;
  trailLocationUrl?: string;
};

const TrailLocationLink = ({ className, trailId, trailLocationName, trailLocationUrl }: TrailLocationLinkProps) => {
  const onLocationClick = () => {
    logTrailDetailsActionTapped({
      trail_id: trailId.toString(),
      trail_page_action: 'park or location link clicked',
      trail_page_location: 'header bar',
      trail_page_type: 'trail detail page'
    });
  };

  return (
    <Link className={className} href={trailLocationUrl} onClick={onLocationClick} target="_blank">
      {trailLocationName}
    </Link>
  );
};

export default TrailLocationLink;
